import { useEffect } from 'react';
import { useAppStore } from '../../useAppStore.ts';
import { useGetDealerBranding } from '@luna-protocol/core/src/queries/useGetDealerBranding.ts';

const UpdateBranding = () => {
  const setOEMType = useAppStore(state => state.setOEMType);
  const { data } = useGetDealerBranding(localStorage.getItem('dealer_id') || '');

  useEffect(() => {
    if (data && data.oem_type) {
      setOEMType(data.oem_type);
    }
  }, [data]);

  return <></>;
};

export default UpdateBranding;
